import React from "react";
import InputMask from "react-input-mask";

const ICPhoneDisplay = props => (
  <InputMask
    className={"phone-display-field " + props.className}
    readOnly={true}
    mask={props.mask ? props.mask : "9999 999 999"}
    value={props.value}
    maskChar={null}
  ></InputMask>
);

export default ICPhoneDisplay;
